module.exports = __webpack_public_path__ + "static/media/agregar_archivo.b85b3033.svg";